import React, { useState } from 'react';

import { useDebouncedValue } from '@mantine/hooks';
import { getMonthRangeDatesMTD } from 'utils/date-functions';

import ReactivatedMembersPageHeader from './components/ReactivatedMembersPageHeader';
import ReactivatedMembersTable from './components/ReactivatedMembersTable';
import { SearchFilters } from './types';

const ReactivatedMembers = (): JSX.Element => {
  const defaultDates = getMonthRangeDatesMTD();
  const initialSearchFiltersValue: SearchFilters = {
    dateRange: [defaultDates[0], defaultDates[1]],
  };
  const [searchFilters, setSearchFilters] = useState<SearchFilters>(initialSearchFiltersValue);
  const [debouncedSearchFilters] = useDebouncedValue<SearchFilters>(searchFilters, 250);
  const [orderingValue, setOrderingValue] = useState<string>('-reactivatedDate');

  return (
    <>
      <ReactivatedMembersPageHeader
        orderingValue={orderingValue}
        initialSearchFiltersValue={initialSearchFiltersValue}
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
      />

      <ReactivatedMembersTable searchFilters={debouncedSearchFilters} setOrderingValue={setOrderingValue} />
    </>
  );
};

export default ReactivatedMembers;
